<template>
  <div>
    <bread-crumb-cas :routeList="breadArrayIndex" labelType="indexs"></bread-crumb-cas>
    <top-bar
      :isShowSelect="isShowSelect"
      placeholder="请选择所属业务"
      :data="data"
      :clickAddButton="clickAddButton"
    ></top-bar>

    <base-table :tableData="tableData" @handleClick="handleClick"></base-table>
    <pagination
      @sizePageChange="paginationChangeProduct"
      :paginationDatas="paginationDataProduct"
    >
    </pagination>
    <modal
      :isShow.sync="dialogShow"
      title="被驳回理由"
      :isShowBtn="isShowBtn"
      :btnText="btnText"
      @one="handleDialog(false)"
      @update:isShow="handleDialog(false)"
      @two="handleDialogSubmit"
    >
      <div class="base-dialog">
        <el-form :model="formList" :rules="rules">
          <el-form-item label="标签名称" prop="nameValue">
            <el-input
              v-model="formList.nameValue"
              class="base-dialog-input"
              autocomplete="off"
              type="text"
              placeholder="请输入"
              maxlength="30"
              show-word-limit
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
    </modal>
    <modal
      :isShow.sync="dialogShowLabel"
      title="新增"
      :isShowBtn="isShowBtn"
      :btnText="btnText"
      @clickHandler="addClickHandler"
      @one="handleDialogLabel(false)"
      @update:isShow="handleDialogLabel(false)"
      @two="handleDialogSubmitLabel"
    >
      <div class="base-dialog">
        <el-form>
          <el-form-item label="索引名称" prop="nameValue">
            <el-input
              v-model="formList.nameValue"
              class="base-dialog-input"
              autocomplete="off"
              type="text"
              placeholder="请输入"
              maxlength="30"
              show-word-limit
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
    </modal>
    <modal
      :isShow="dialogShowEditLabel"
      title="编辑"
      :isShowBtn="isShowBtn"
      :btnText="btnText"
      @clickHandler="editClickHandler"
      @one="handleDialogLabel(false)"
      @update:isShow="handleDialogLabel(false)"
      @two="handleDialogSubmitLabel"
    >
      <div class="base-dialog">
        <el-form>
          <el-form-item label="索引名称" prop="nameValue">
            <el-input
              v-model="formList.nameValue"
              class="base-dialog-input"
              autocomplete="off"
              type="text"
              placeholder="请输入"
              maxlength="20"
              show-word-limit
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
    </modal>
    <modal
      :isShow.sync="deleteDialog"
      title="删除"
      :isShowBtn="isShowBtn"
      :btnText="btnText"
      @clickHandler="deleteClickHandler"
    >
      <div class="dialogVal">确认删除</div>
    </modal>
    <modal
      :isShow.sync="attributeShow"
      title="属性"
      :isShowBtn="isShowBtn"
      :btnText="btnText"
      @clickHandler="btnTextClickHandler"
    >
      <div class="dialogVal">
        <el-checkbox-group v-model="checkedCities" @change="changeCheck">
          <el-checkbox v-for="item in checkList" :key="item.id" :label="item.id">{{ item.name }}</el-checkbox>
        </el-checkbox-group>
      </div>
    </modal>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import pagination from '@/components/pagination'
import topBar from "@/components/topBar"
import baseTable from "@/components/baseTable"
import breadCrumbCas from "@/components/breadCrumbCas"
import modal from "@/components/modal"
import {
  contentIndexManagePage,
  contentIndexManageSave,
  contentIndexManageUpdate,
  contentIndexManageDelete,
} from "@/api/admin.js";

export default {
  name: "firstIndex",
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入名称'))
      } else {
        callback()
      }
    }
    return {
      attributeShow: false, // 属性弹窗
      checkList: [
        {
          id: 1,
          name: '写手端不可见'
        },
        {
          id: 2,
          name: 'C端用户不可见'
        }],
      checkedCities: [],
      paginationDataProduct: {
        total: 0,
        currentPage: 1,
        pageSize: 10
      },
      tableData: {
        tableList: [],
        tableHeader: [
          {
            label: '索引ID',
            prop: 'indexId'
          },
          {
            label: '索引名称',
            prop: 'name'
          },
          {
            label: '层级',
            prop: 'level'
          },
          {
            label: '创建时间',
            prop: 'createTime'
          },
          {
            label: '创建人',
            prop: 'createUser'
          },

        ],
        tableType: 12
      },
      isShowSelect: false,
      // 删除弹框
      deleteDialog: false,
      data: [],
      tableVal: {},
      btnText: ["取消", "确认"],
      // 移动弹框
      moveDialog: false,
      // 合并弹框
      mergeDialog: false,
      mergeMoveBtnText: ["取消", "提交"],
      isShowBtn: [true, true, false],
      nameValue: "",
      dialogShow: false,
      dialogShowLabel: false,
      dialogShowEditLabel: false,
      labelInfos: null,
      formList: {
        nameValue: "",
        nameType: "",
      },
      rules: {
        nameValue: [
          {validator: validatePass, trigger: 'blur'}
        ],
      }
    }
  },
  computed: {
    ...mapState([
      'breadArrayIndex',
    ]),
  },
  components: {
    baseTable,
    topBar,
    breadCrumbCas,
    modal,
    pagination
  },
  mounted() {
    this.labelLevel = this?.$route?.params?.id;
    this.pageContentLabelsByGroupId();
  },
  watch: {
    'formList.nameValue'(newValue, oldValue) {
      if (this.$utils.specialCharacters(newValue)) {
        this.$message({
          message: '禁止输入特殊字符',
          type: 'warning'
        });
        this.formList.nameValue = this.$utils.removalSpace(newValue)
      }
    },
    '$route.params.id'(newVal, oldValue) {
      this.labelLevel = this?.$route?.params?.id;
      this.pageContentLabelsByGroupId();
    }
  },
  methods: {
    changeCheck(val) {
    },
    // 属性弹窗
    btnTextClickHandler(val) {
      if (val === 'one') {
        this.attributeShow = false
      } else if (val === 'two') {
        this.attributeShow = false
      }
    },
    // 获取一级标签
    async pageContentLabelsByGroupId() {
      const pid = this.$route.query.groupId;
      let res = await contentIndexManagePage({
        pageNo: this.paginationDataProduct.currentPage,
        pageSize: this.paginationDataProduct.pageSize,
        pid,
        level: this.$route.params.id,
      })
      sessionStorage.setItem('groupID', this.$route.query.groupId)
      this.tableData.tableList.splice(0, this.tableData.tableList.length)
      this.paginationDataProduct.total = res.totalCount
      this.paginationDataProduct.currentPage = res.pageNo
      this.paginationDataProduct.pageSize = res.pageSize
      res.data.map(item => {
        this.tableData.tableList.push(item)
      })
    },
    paginationChangeProduct(val) {
      this.paginationDataProduct = val
      this.pageContentLabelsByGroupId()
    },
    handleClick(val) {
      if (val.type === 'edit') {
        this.dialogShowEditLabel = true
        this.formList.nameValue = val.val.name
        this.editLabelName(val)

      } else if (val.type === 'indexOperate') {
        // 跳转子级标签路由
        this.$router.push({
          path: `/indexManage/${+this?.$route?.params?.id + 1}`,
          query: {groupId: val.val.indexId},
        })
        // 根据一级标签id分页查询子标签列表

      } else if (val.type === 'delete') {
        this.deleteDialog = true
        this.tableVal = val.val

      } else if (val.type === 'attribute') {
        this.attributeShow = true
        this.tableVal = val.val
      } else if (val.type === 'moveLabel') {
        this.moveDialog = true
        this.tableVal = val.val
      } else if (val.type === 'mergeLabel') {
        this.mergeDialog = true
        this.tableVal = val.val
      }
    },
    deleteClickHandler(val) {
      if (val === 'one') {
        this.deleteDialog = false
      } else if (val === 'two') {
        this.deleteLabelGroupById(this.tableVal)
        // this.deleteDialog=false
      }
    },
    deleteLabelGroupById(val) {
      // 删除一级标签
      contentIndexManageDelete({
        indexId: val.indexId
      })
        .then(res => {
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.deleteDialog = false
          this.paginationDataProduct.currentPage = 1;
          this.pageContentLabelsByGroupId();

        })
        .catch(res => {
          this.$message.error(
            res.msg
          )
        })
    },
    // 增加标签弹框
    addClickHandler(val) {
      if (val === 'one') {
        this.dialogShowLabel = false
      } else if (val === 'two') {
        if (this.formList.nameValue && this.formList.nameValue.trim() != '') {
          // 添加标签
          contentIndexManageSave({
            pid: this.$route.query.groupId,
            name: this.formList.nameValue,
            level: this.labelLevel,
          }).then(res => {
            this.$message({
              message: '添加成功',
              type: 'success'
            })
            this.dialogShowLabel = false
            this.pageContentLabelsByGroupId();
            // sessionStorage.setItem('labelGroupId','')
            // this.pageContentLabelGroups()
          }).catch(res => {
            this.$message.error(res.msg)
          })
        } else {
          this.$message.error('请输入标签名称')
        }

      }
    },
    // 编辑
    editClickHandler(val) {
      if (val === 'one') {
        this.dialogShowEditLabel = false
      } else if (val === 'two') {
        if (this.formList.nameValue && this.formList.nameValue.trim() != '') {
          contentIndexManageUpdate({
            indexId: this.labelInfos.indexId,
            pid:this.$route.query.groupId,
            name: this.formList.nameValue,
            level: this.labelLevel,
          }).then(res => {
            this.$message({
              message: '更新成功',
              type: 'success'
            })
            this.dialogShowEditLabel = false
            this.pageContentLabelsByGroupId();
          }).catch(res => {
            this.$message.error(res.msg)
          })
        } else {
          this.$message.error('请输入标签名称')
        }

      }
    },
    // 更新一级标签
    editLabelName(target) {
      this.labelInfos = target.val
    },
    // 新增标签
    clickAddButton() {
      this.formList.nameValue = ''
      this.dialogShowLabel = true
    },
    handleDialog(val) {
      this.dialogShow = val
    },
    handleDialogLabel(val) {
      // dialogShowLabel
      this.dialogShowLabel = val
      this.dialogShowEditLabel = val
    },
    handleDialogSubmit() {
      this.handleDialog(false)
    },
    handleDialogSubmitLabel() {
      this.handleDialogLabel(false)
    },
  },
};
</script>

<style lang="scss" scoped>

.dialogVal {
  color: #5f5f6b;
  font-size: 16px;
  padding: 30px 0px;
  padding-bottom: 0px;
  text-align: center;
}

.common-audit-tabel {
  background: rgba(255, 255, 255, 1);
  border-radius: 4px;
  background: white;
  margin-top: 14px;
}

.input-container {
  display: flex;
  justify-content: center;
  padding-top: 20px;

  .input-suffix {
    .el-input {
      width: 276px;
    }
  }
}

.base-dialog {
  width: 400px;
  padding: 30px 26px 0;
  position: relative;
  font-size: 14px;
  color: #2c3443;

  &-input {
    width: 276px;
  }

  &-textarea {
    width: 276px;
    padding-top: 10px;
  }

  .el-form-item__label {
    width: 68px;
    font-weight: bolder;
  }

  .el-input__inner {
    height: 32px;
  }

  // .el-form-item__error {
  //   left: 68px;
  // }
  &__body {
    padding: 30px 26px;
  }

  &__header {
    background-color: #f7f8fb;
    height: 46px;
    display: flex;
    align-items: center;

    .el-dialog__title {
      font-size: 16px;
      color: #333840;
      font-weight: bolder;
    }
  }
}
</style>
